import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const ReturnsRefunds = () => {
  return (
    <div>
      <Navbar />
      <div style={{ minHeight: '100vh', backgroundColor: '#fff', paddingTop: '120px', paddingBottom: '60px' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>
          <Link to="/" style={{ display: 'inline-block', marginBottom: '20px', color: '#dc2626', textDecoration: 'none', fontSize: '14px' }}>
            ← Back to Home
          </Link>
          
          <div style={{ backgroundColor: '#000', color: '#fff', padding: '30px', marginBottom: '30px', borderRadius: '8px' }}>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '10px' }}>Returns & Refunds Policy</h1>
            <p style={{ opacity: 0.9 }}>MAXRAD SOFTWARE INDIA PVT LTD (Brand name ARTCARDO under the division DULCIA.ART)</p>
            <p style={{ opacity: 0.7, marginTop: '10px' }}>Effective Date: January 2025</p>
          </div>

          <div style={{ backgroundColor: '#f9fafb', padding: '30px', borderRadius: '8px', lineHeight: '1.8' }}>
            
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>1. Introduction</h2>
              <p style={{ color: '#374151', marginBottom: '15px' }}>
                At ARTCARDO, we are committed to ensuring customer satisfaction with every purchase. This Returns & Refunds Policy outlines the conditions, procedures, and responsibilities for returns and refunds of artworks and handcrafted products purchased through our platform.
              </p>
              <p style={{ color: '#374151' }}>
                All artwork sold on ARTCARDO is handcrafted and original. We strive to ensure accurate product representation and quality, but in rare cases where products arrive damaged, defective, or significantly different from their description, we have established a fair return and refund process.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>2. Eligibility for Returns</h2>
              <p style={{ color: '#374151', marginBottom: '10px' }}>Returns are accepted ONLY under the following conditions:</p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc', marginBottom: '15px' }}>
                <li style={{ marginBottom: '8px' }}><strong>Production Defects:</strong> Manufacturing flaws, cracks, broken parts, or structural damage present at the time of delivery</li>
                <li style={{ marginBottom: '8px' }}><strong>Damage During Transit:</strong> Product arrived damaged due to shipping mishandling (with photographic evidence)</li>
                <li style={{ marginBottom: '8px' }}><strong>Wrong Item Delivered:</strong> You received a completely different product than what was ordered</li>
                <li style={{ marginBottom: '8px' }}><strong>Significantly Different from Description:</strong> Product materially differs from listing (size, color, material) beyond reasonable artistic variation</li>
                <li style={{ marginBottom: '8px' }}><strong>Non-Receipt of Product:</strong> Product not received within 15 days of dispatch confirmation</li>
              </ul>
              
              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#dc2626', marginTop: '20px', marginBottom: '10px' }}>2.1 Non-Returnable Items</h3>
              <p style={{ color: '#374151', marginBottom: '10px' }}>The following are NOT eligible for return:</p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc' }}>
                <li style={{ marginBottom: '8px' }}>Change of mind or buyer's remorse</li>
                <li style={{ marginBottom: '8px' }}>Minor color variations due to screen display differences</li>
                <li style={{ marginBottom: '8px' }}>Natural variations in handcrafted items (expected in handmade art)</li>
                <li style={{ marginBottom: '8px' }}>Products used, altered, or damaged by the buyer after delivery</li>
                <li style={{ marginBottom: '8px' }}>Custom-made or personalized artworks (unless defective)</li>
                <li style={{ marginBottom: '8px' }}>Products with original packaging opened or damaged by buyer</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>3. Return Window</h2>
              <p style={{ color: '#374151', marginBottom: '10px' }}>
                <strong>All return requests must be raised within 5 calendar days of product delivery.</strong>
              </p>
              <p style={{ color: '#374151', marginBottom: '10px' }}>
                Return requests submitted after 5 days will NOT be accepted unless the defect was hidden and could not be reasonably discovered within this timeframe.
              </p>
              <p style={{ color: '#374151' }}>
                Delivery date is confirmed by courier tracking or delivery confirmation receipt.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>4. How to Initiate a Return</h2>
              <p style={{ color: '#374151', marginBottom: '15px' }}>To request a return, follow these steps:</p>
              
              <div style={{ backgroundColor: '#fef2f2', padding: '20px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #fecaca' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#991b1b', marginBottom: '10px' }}>Step 1: Contact ARTCARDO Support</h3>
                <p style={{ color: '#374151', marginBottom: '5px' }}>Email: <a href="mailto:dulciaart@gmail.com" style={{ color: '#dc2626', textDecoration: 'underline' }}>dulciaart@gmail.com</a></p>
                <p style={{ color: '#374151' }}>WhatsApp: <a href="tel:+919019028615" style={{ color: '#dc2626', textDecoration: 'underline' }}>+91 90190 28615</a></p>
              </div>

              <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', marginBottom: '15px', border: '1px solid #e5e7eb' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '10px' }}>Step 2: Provide Required Information</h3>
                <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc' }}>
                  <li style={{ marginBottom: '6px' }}>Order Number (Invoice ID)</li>
                  <li style={{ marginBottom: '6px' }}>Product Name</li>
                  <li style={{ marginBottom: '6px' }}>Delivery Date</li>
                  <li style={{ marginBottom: '6px' }}>Reason for Return (detailed description)</li>
                  <li style={{ marginBottom: '6px' }}><strong>Photographic Evidence:</strong> Minimum 3-4 clear photos showing:
                    <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
                      <li>Overall product view</li>
                      <li>Close-up of defect/damage</li>
                      <li>Packaging condition (if damaged in transit)</li>
                      <li>Product label/tag (if applicable)</li>
                    </ul>
                  </li>
                  <li style={{ marginBottom: '6px' }}>Video evidence (if applicable for functional issues)</li>
                </ul>
              </div>

              <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '10px' }}>⏱️ Step 3: Wait for Verification</h3>
                <p style={{ color: '#374151' }}>
                  Our team will review your request and evidence within <strong>2-3 business days</strong>. We may contact the artist for their input or request additional information from you.
                </p>
              </div>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>5. Return Approval & Shipping</h2>
              
              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#374151', marginTop: '20px', marginBottom: '10px' }}>5.1 If Return is Approved</h3>
              <p style={{ color: '#374151', marginBottom: '10px' }}>
                Once your return is approved, you will receive a Return Authorization Number (RAN) and return shipping instructions.
              </p>
              
              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#374151', marginTop: '20px', marginBottom: '10px' }}>5.2 Return Shipping Costs</h3>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc', marginBottom: '15px' }}>
                <li style={{ marginBottom: '8px' }}><strong>Defective/Damaged Products:</strong> Artist bears return shipping cost (prepaid return label provided)</li>
                <li style={{ marginBottom: '8px' }}><strong>Buyer's Mistake:</strong> Buyer bears return shipping cost (not eligible under this policy)</li>
                <li style={{ marginBottom: '8px' }}><strong>Disputed Cases:</strong> ARTCARDO may mediate and decide cost-sharing</li>
              </ul>

              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#374151', marginTop: '20px', marginBottom: '10px' }}>5.3 Return Packaging Requirements</h3>
              <p style={{ color: '#374151', marginBottom: '10px' }}>
                Products must be returned in original packaging (if available) with all accessories, tags, and documentation. Pack securely to prevent damage during return transit.
              </p>

              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#374151', marginTop: '20px', marginBottom: '10px' }}>5.4 If Return is Rejected</h3>
              <p style={{ color: '#374151' }}>
                If the return request does not meet our eligibility criteria, we will notify you with a detailed explanation. You may appeal this decision within 3 days.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>6. Refund Process</h2>
              
              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#374151', marginTop: '20px', marginBottom: '10px' }}>6.1 Refund Timeline</h3>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc', marginBottom: '15px' }}>
                <li style={{ marginBottom: '8px' }}><strong>After Product Receipt:</strong> Once we receive the returned product and verify its condition (2-3 business days)</li>
                <li style={{ marginBottom: '8px' }}><strong>Refund Initiation:</strong> Within 5-7 business days of verification</li>
                <li style={{ marginBottom: '8px' }}><strong>Bank Credit:</strong> 5-10 business days (depends on your bank)</li>
                <li style={{ marginBottom: '8px' }}><strong>Total Time:</strong> Approximately 12-20 business days from return approval</li>
              </ul>

              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#374151', marginTop: '20px', marginBottom: '10px' }}>6.2 Refund Method</h3>
              <p style={{ color: '#374151', marginBottom: '10px' }}>
                Refunds will be processed to the <strong>original payment method</strong> used during purchase:
              </p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc', marginBottom: '15px' }}>
                <li style={{ marginBottom: '8px' }}>Credit/Debit Card: Refund to same card</li>
                <li style={{ marginBottom: '8px' }}>UPI: Refund to linked bank account</li>
                <li style={{ marginBottom: '8px' }}>Net Banking: Refund to same account</li>
              </ul>

              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#374151', marginTop: '20px', marginBottom: '10px' }}>6.3 Refund Amount</h3>
              <p style={{ color: '#374151', marginBottom: '10px' }}>
                <strong>Full refund includes:</strong>
              </p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc', marginBottom: '15px' }}>
                <li style={{ marginBottom: '8px' }}>Product base price</li>
                <li style={{ marginBottom: '8px' }}>GST amount paid</li>
                <li style={{ marginBottom: '8px' }}>Original shipping charges (if product was defective/damaged)</li>
              </ul>

              <p style={{ color: '#374151', marginBottom: '10px' }}>
                <strong>Deductions (if applicable):</strong>
              </p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc' }}>
                <li style={{ marginBottom: '8px' }}>Razorpay payment gateway transaction fees (non-refundable as per payment processor policy)</li>
                <li style={{ marginBottom: '8px' }}>Return shipping cost (if buyer's responsibility)</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>7. Artist Obligations & Quality Standards</h2>
              
              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#374151', marginTop: '20px', marginBottom: '10px' }}>7.1 Artist Responsibilities</h3>
              <p style={{ color: '#374151', marginBottom: '10px' }}>All artists on ARTCARDO agree to:</p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc', marginBottom: '15px' }}>
                <li style={{ marginBottom: '8px' }}>Provide accurate product descriptions, dimensions, materials, and photographs</li>
                <li style={{ marginBottom: '8px' }}>Ensure products are free from defects before shipping</li>
                <li style={{ marginBottom: '8px' }}>Pack products securely to prevent damage during transit</li>
                <li style={{ marginBottom: '8px' }}>Accept valid return requests and cooperate with the return process</li>
                <li style={{ marginBottom: '8px' }}>Bear the cost of return shipping for defective/damaged products</li>
              </ul>

              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#374151', marginTop: '20px', marginBottom: '10px' }}>7.2 Commission Handling on Returns</h3>
              <p style={{ color: '#374151', marginBottom: '10px' }}>
                When a return is approved and refund is processed:
              </p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc', marginBottom: '15px' }}>
                <li style={{ marginBottom: '8px' }}>The <strong>15% platform commission</strong> is refunded back to the artist</li>
                <li style={{ marginBottom: '8px' }}>The artist receives the product back (in returned condition)</li>
                <li style={{ marginBottom: '8px' }}>No commission is charged on returned/refunded orders</li>
              </ul>

              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#dc2626', marginTop: '20px', marginBottom: '10px' }}>7.3 Penalty for Repeated Quality Issues</h3>
              <p style={{ color: '#374151', marginBottom: '10px' }}>
                If an artist receives <strong>3 or more valid return requests</strong> within 6 months due to product defects or misrepresentation:
              </p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc' }}>
                <li style={{ marginBottom: '8px' }}>First Warning: Official notice and quality review</li>
                <li style={{ marginBottom: '8px' }}>Second Warning: Temporary suspension of new product listings (30 days)</li>
                <li style={{ marginBottom: '8px' }}>Third Instance: Account suspension or termination</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>8. Dispute Resolution</h2>
              <p style={{ color: '#374151', marginBottom: '10px' }}>
                If there is a disagreement between buyer and artist regarding a return request:
              </p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc', marginBottom: '15px' }}>
                <li style={{ marginBottom: '8px' }}><strong>Mediation:</strong> ARTCARDO will mediate and review all evidence objectively</li>
                <li style={{ marginBottom: '8px' }}><strong>Expert Opinion:</strong> We may consult independent art experts if needed</li>
                <li style={{ marginBottom: '8px' }}><strong>Final Decision:</strong> ARTCARDO's decision is final and binding on both parties</li>
                <li style={{ marginBottom: '8px' }}><strong>Appeal:</strong> Either party may appeal within 3 days with new evidence</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>9. Exchanges</h2>
              <p style={{ color: '#374151' }}>
                <strong>ARTCARDO does not offer direct product exchanges.</strong> If you wish to receive a different product, you must:
              </p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc', marginTop: '10px' }}>
                <li style={{ marginBottom: '8px' }}>Complete the return and refund process for the original product</li>
                <li style={{ marginBottom: '8px' }}>Place a new order for the desired product</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>10. Cancellation Before Shipping</h2>
              <p style={{ color: '#374151', marginBottom: '10px' }}>
                Orders can be cancelled <strong>before dispatch</strong> by contacting ARTCARDO support:
              </p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc', marginBottom: '15px' }}>
                <li style={{ marginBottom: '8px' }}><strong>Before Artist Ships:</strong> Full refund minus payment gateway fees (if applicable)</li>
                <li style={{ marginBottom: '8px' }}><strong>After Artist Ships:</strong> Cancellation not allowed; follow return process after delivery</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>11. Contact Information</h2>
              <p style={{ color: '#374151', marginBottom: '10px' }}>
                For all return and refund queries, contact:
              </p>
              <div style={{ backgroundColor: '#fef2f2', padding: '20px', borderRadius: '8px', border: '1px solid #fecaca' }}>
                <p style={{ color: '#374151' }}><strong>MAXRAD SOFTWARE INDIA PVT LTD</strong></p>
                <p style={{ color: '#374151' }}>(Brand name ARTCARDO under the division DULCIA.ART)</p>
                <p style={{ color: '#374151', marginTop: '10px' }}>Email: <a href="mailto:dulciaart@gmail.com" style={{ color: '#dc2626', textDecoration: 'underline' }}>dulciaart@gmail.com</a></p>
                <p style={{ color: '#374151' }}>📱 WhatsApp: <a href="tel:+919019028615" style={{ color: '#dc2626', textDecoration: 'underline' }}>+91 90190 28615</a></p>
                <p style={{ color: '#374151', marginTop: '10px' }}>📍 Address: 1542, 17th B, Main, 5th Block, HBR Layout, Bangalore - 560043, Karnataka, India</p>
                <p style={{ color: '#374151', marginTop: '10px' }}><strong>Response Time:</strong> Within 2-3 business days</p>
              </div>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>12. Policy Updates</h2>
              <p style={{ color: '#374151' }}>
                This Returns & Refunds Policy may be updated periodically. All changes will be posted on this page with an updated "Effective Date." Continued use of the platform constitutes acceptance of the revised policy.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>13. Governing Law</h2>
              <p style={{ color: '#374151' }}>
                This policy is governed by the laws of India. All disputes shall be subject to the exclusive jurisdiction of courts in Bangalore, Karnataka.
              </p>
            </section>

          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ReturnsRefunds;
